import React, { useState } from 'react';
import CockpitBoardGroup from './components/CockpitBoard';
import VehicleBoard from './components/VehicleBoard';
import IssueBoard from './IssueBoard';
import './index.scss';
import { Tabs, TabsProps } from 'antd';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import './index.scss';
import { analyzeLog, transIssueDurationTime } from '@/utils/util';
import IssueSummary from '@/components/IssueSummary';
const tabs: TabsProps['items'] = [
  {
    label: '座席看板',
    key: 'cockpit_board',
  },
  {
    label: '工单看板',
    key: 'issue_board',
  },
  {
    label: '车辆绑定',
    key: 'bind_vehicle',
  },
];

const CockpitManage = () => {
  const [tabKey, setTabKey] = useState<string>(tabs[0].key);
  const renderContent = () => {
    switch (tabKey) {
      case 'cockpit_board':
        return <CockpitBoardGroup />;
      case 'bind_vehicle':
        return <VehicleBoard />;
      case 'issue_board':
        return <IssueBoard />;
      default:
        return <></>;
    }
  };

  return (
    <div className="cockpit-manage-conatiner">
      <div className="cockpit-manage-head">
        <IssueSummary />
      </div>
      <div className="cockpit-manage-body">
        <div className="tabs-header">
          <Tabs
            items={tabs}
            defaultActiveKey={tabKey}
            onChange={(tabKey: string) => {
              setTabKey(tabKey);
              analyzeLog(tabKey, '{}');
            }}
          ></Tabs>
        </div>

        <div className="manage-content">{renderContent()}</div>
      </div>
    </div>
  );
};
export default React.memo(CockpitManage);
